import { cn } from '@/lib/cn'
import { t, useLanguage } from '@/lib/i18n'

export function Brand({ compact = false, exam = false }: { compact?: boolean; exam?: boolean }) {
  useLanguage()
  return (
    <div className={cn('brand-lockup', compact && 'brand-lockup--compact', exam ? 'brand-lockup--exam' : 'brand-lockup--soft')}>
      <img src="/assets/Edvantage-Logo.svg" alt="Edvantage" />
      {!exam && <i className="brand-tick" aria-hidden="true" />}
      {!compact && <span>{exam ? 'IELTS preparation mock' : t('IELTS · Study journal')}</span>}
    </div>
  )
}
